import { render, staticRenderFns } from "./Karyawan.vue?vue&type=template&id=5e6146ad"
import script from "./Karyawan.vue?vue&type=script&lang=js"
export * from "./Karyawan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports